<div class="content-document-info flip-vertical-left">
  <div class="info">
    <div class="control-value">
      <p id="idNumberText"><strong>{{ copyService.copies.back_document_info_texts.id_number_text }}</strong></p>
      <p class="value" id="idNumber">{{ getTransformedDocument(documentInfo.document_number) }}</p>
    </div>

    <div class="control-value">
      <p id="lastNameText"><strong>{{ copyService.copies.back_document_info_texts.lastname_text }}</strong></p>
      <p id="userLastName" class="value">{{ documentInfo.primary_lastname + ' ' + documentInfo.second_lastname }}</p>
    </div>

    <div class="control-value">
      <p id="nameText"><strong>{{ copyService.copies.back_document_info_texts.name_text }}</strong></p>
      <p id="userName" class="value">{{ documentInfo.firstname + ' ' + documentInfo.middlename }}</p>
    </div>
  </div>
  <div class="image">
    <img src="assets/images/user.svg" alt="" id="generalImg">
  </div>
</div>
